import { StyleSheet, Text, TextProps } from "react-native"


export const PlaceTextStyle = StyleSheet.create({
    font: {
        fontFamily: 'Alegreya Sans'
    }
})
export const PlaceText = ({ children, style, ...props }: TextProps) => {
    return <Text {...props} style={[PlaceTextStyle.font, style]}>{children}</Text>
}